import Typography from '@material-ui/core/Typography'
import intersectionBy from 'lodash/intersectionBy'
import isEmpty from 'lodash/isEmpty'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TableViewStoreContext } from '../StandardTableView'

export interface ISelectionCountRowProps {
  width?: number
  maxSelectionLimit: number
  height: number
  setFilterData: any
  showCountDetailOnly: boolean
}

const StyledContainerNew = styled.div<{ width: number; height: number }>`
  display: flex;
  height: 100%;
  width: ${props => props.width + 'px'};
  align-items: center;
  align-self: center;
}
`
const textStyle = {
  font: 'var(--typography-body1)',
  letterSpacing: 'var(--label-typography-letter-spacing)',
  color: 'black'
}
export const SelectionCountRow: React.FunctionComponent<ISelectionCountRowProps> = ({
  width,
  height,
  maxSelectionLimit,
  setFilterData,
  showCountDetailOnly
}) => {
  return useObserver(function useHook() {
    const { selectedRows, filteredColumns, getFilteredData } = React.useContext(
      TableViewStoreContext
    ) as any
    const getFilteredRows = getFilteredData()
    const dataForApplyToSelected = intersectionBy(getFilteredRows, selectedRows, 'id')

    const { t } = useTranslation()
    setFilterData && setFilterData(dataForApplyToSelected, !!getFilteredRows)

    const countText =
      showCountDetailOnly && getFilteredRows
        ? dataForApplyToSelected.length
        : selectedRows
        ? selectedRows.length
        : 0
    const appliedToRowsMessage =
      !showCountDetailOnly && !isEmpty(filteredColumns) && selectedRows.length
        ? `(Changes will be applied on ${dataForApplyToSelected.length} out of 
    ${selectedRows?.length} selected rows)`
        : ''
    return (
      <div>
        <StyledContainerNew width={width as number} height={height}>
          <Typography
            style={{
              ...textStyle,
              display: 'inline-block',
              whiteSpace: 'nowrap'
            }}
          >
            {countText} {t('bb.common.label.selectedOutOf', 'selected out of ')}
            {maxSelectionLimit}
            {appliedToRowsMessage}
          </Typography>
        </StyledContainerNew>
      </div>
    )
  })
}
